module.exports = ".input-text {\n  margin-top: -28px; }\n\n.w-75 {\n  width: 75%; }\n\n.text-underline {\n  text-decoration: underline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gto-token/validate-token/validate-token.component.scss
// module id = ./src/app/components/gto-token/validate-token/validate-token.component.scss
// module chunks = main